<template>
  <div>
    <h4 style="margin-top: 0px; margin-bottom: 10px">Longest repeats in the genome</h4>
    <el-table :data="tableData" :max-height="470" stripe border :header-cell-style="headerStyle">
        <el-table-column prop="location" label="Location"></el-table-column>
        <el-table-column prop="RepLength" label="Length"></el-table-column>
        <el-table-column prop="RepClass" label="Repeat class"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'TableLongestRepeats',
  props: {
    info: {
      type: Object
    }
  },
  data () {
    return {
      headerStyle: {
        "background-color": "#EEF1F6",
        "color": "#324157",
        "font-weight": "bold",
        "font-size": "1.1em",
        "border": "1px solid #dcdcdc"
      }
    }
  },
  computed: {
    tableData () {
      const data = this.info.RepInfo.LongestRepeats;
      for (let d of data) {
        d.location = `${d.Seq}:${d.Start}-${d.End}`
      }
      return data
    }
  }
}
</script>
